module.exports = __webpack_public_path__ + "assets/img/botanical_head.375fe0ee.svg";